let current = null;

const newId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const beginSearch = () => {
  if (current && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(
      `searchTelemetry: search ${current.id} was never ended after ${current.attempt} attempt(s). ` +
        'A flow returned without cancelling its retry, so that search is missing its outcome in ' +
        'the logs. Cancel on every path that settles a search.',
    );
  }
  current = { id: newId(), attempt: 1 };
  return current;
};

export const nextAttempt = () => {
  if (current) current.attempt += 1;
  return current;
};

export const currentSearch = () => current;

export const endSearch = () => {
  current = null;
};
